import { render } from "./PlateauView.vue?vue&type=template&id=d30decc0"
import script from "./PlateauView.vue?vue&type=script&lang=js"
export * from "./PlateauView.vue?vue&type=script&lang=js"

import "./PlateauView.vue?vue&type=style&index=0&id=d30decc0&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__